import axiosInstance from './axiosInstance';

export const getMenuByRestaurant = async (restaurantGuid: string) => {
  const response = await axiosInstance.get(`/menu/restaurant/${restaurantGuid}`);
  return response.data;
};

export const createMenuItem = async (data: any) => {
  const formData = new FormData();
  formData.append('RestaurantGuid', data.restaurantGuid);
  formData.append('Name', data.name);
  formData.append('Category', data.category);
  if (data.subcategory) formData.append('Subcategory', data.subcategory);
  if (data.cuisineType && Array.isArray(data.cuisineType)) formData.append('CuisineType', JSON.stringify(data.cuisineType));
  formData.append('ShortDescription', data.shortDescription || '');
  formData.append('Description', data.description || '');
  if (data.dishTags && Array.isArray(data.dishTags)) formData.append('DishTags', JSON.stringify(data.dishTags));
  if (data.spiceLevel) formData.append('SpiceLevel', data.spiceLevel);
  formData.append('Price', String(data.price));
  if (data.discountPrice !== undefined) formData.append('DiscountPrice', String(data.discountPrice));
  formData.append('TaxesApplicable', String(data.taxesApplicable));
  if (data.servingSize) formData.append('ServingSize', data.servingSize);
  if (data.availableDays && Array.isArray(data.availableDays)) formData.append('AvailableDays', JSON.stringify(data.availableDays));
  if (data.availableFrom) formData.append('AvailableFrom', data.availableFrom);
  if (data.availableTo) formData.append('AvailableTo', data.availableTo);
  if (data.keyIngredients && Array.isArray(data.keyIngredients)) formData.append('KeyIngredients', JSON.stringify(data.keyIngredients));
  if (data.allergens && Array.isArray(data.allergens)) formData.append('Allergens', JSON.stringify(data.allergens));
  formData.append('ImageUrl', data.imageUrl || '');
  formData.append('IsAvailable', String(data.isAvailable));
  if (data.itemImage) {
    formData.append('ItemImage', data.itemImage);
  }
  if (data.defaultEstimationTimeInMinutes !== undefined) formData.append('DefaultEstimationTimeInMinutes', String(data.defaultEstimationTimeInMinutes));
  const response = await axiosInstance.post('/menu', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const updateMenuItem = async (
  id: string,
  data: any
) => {
  const formData = new FormData();
  formData.append('Id', data.id || id);
  formData.append('RestaurantGuid', data.restaurantGuid);
  formData.append('Name', data.name);
  formData.append('Category', data.category);
  if (data.subcategory) formData.append('Subcategory', data.subcategory);
  if (data.cuisineType && Array.isArray(data.cuisineType)) formData.append('CuisineType', JSON.stringify(data.cuisineType));
  formData.append('ShortDescription', data.shortDescription || '');
  formData.append('Description', data.description || '');
  if (data.dishTags && Array.isArray(data.dishTags)) formData.append('DishTags', JSON.stringify(data.dishTags));
  if (data.spiceLevel) formData.append('SpiceLevel', data.spiceLevel);
  formData.append('Price', String(data.price));
  if (data.discountPrice !== undefined && data.discountPrice !== null) formData.append('DiscountPrice', String(data.discountPrice));
  formData.append('TaxesApplicable', String(data.taxesApplicable));
  if (data.servingSize) formData.append('ServingSize', data.servingSize);
  if (data.availableDays && Array.isArray(data.availableDays)) formData.append('AvailableDays', JSON.stringify(data.availableDays));
  if (data.availableFrom) formData.append('AvailableFrom', data.availableFrom);
  if (data.availableTo) formData.append('AvailableTo', data.availableTo);
  if (data.keyIngredients && Array.isArray(data.keyIngredients)) formData.append('KeyIngredients', JSON.stringify(data.keyIngredients));
  if (data.allergens && Array.isArray(data.allergens)) formData.append('Allergens', JSON.stringify(data.allergens));
  formData.append('ImageUrl', data.imageUrl || '');
  formData.append('IsAvailable', String(data.isAvailable));
  if (data.itemImage) {
    formData.append('ItemImage', data.itemImage);
  }
  if (data.defaultEstimationTimeInMinutes !== undefined) formData.append('DefaultEstimationTimeInMinutes', String(data.defaultEstimationTimeInMinutes));
  const response = await axiosInstance.put(`/menu/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deleteMenuItem = (id: string) =>
  axiosInstance.delete(`/menu/${id}`);

export const updateMenuItemAvailability = async (menuItemId: string, isAvailable: boolean) => {
  const response = await axiosInstance.put(`/menu/UpdateMenuItemAvailablity?menuItemId=${menuItemId}&isAvailable=${isAvailable}`);
  return response.data;
}